import {css} from 'styled-components';
import {transparentize} from 'polished';

/**
 * The helper create outline
 * @param {number} size
 * @param {number} range
 * @return {
 *    FlattenInterpolation
 *    <ThemedStyledProps<{}, AnyIfEmpty<DefaultTheme>>>
 *   }
 */
export default function outline(size: number, range: number = 2) {
  return css`
    box-shadow: 0 0 0 ${range}px ${({theme}) => `
      ${transparentize(.3, theme.colors.primary)}
    `}, 0 0 0 ${size}px ${({theme}) => `
      ${transparentize(.9, theme.colors.primary)}
    `};
  `;
}
